var angular = require('angular');
var _ = require('underscore');
require('../edit-btn')

 angular
  .module("app.directives")
  .directive('rrInlineEdit', function($compile, $parse, ngDialog){
    return {
      restrict: 'A',
      scope: {
          member: '=rrInlineEdit',
          rrInlineEditSelectFrom: '='
      },
      link: function(scope, element, attrs){
        scope.launchDialog = function(){
          var rrInlineEditAttrNameParts = attrs.rrInlineEdit.split('.');
          var variableName = camelCaseToTitleCase(rrInlineEditAttrNameParts[rrInlineEditAttrNameParts.length - 1]);
          ngDialog.open({
            template:  scope.rrInlineEditSelectFrom ? require('./rr-inline-edit-select.pug')() : require('./rr-inline-edit.pug')(),
            controller: function($scope) {
              $scope.variableName = variableName;
              $scope.rrInlineEditSelectFrom = scope.rrInlineEditSelectFrom;
              $scope.initialValue =JSON.parse(JSON.stringify(scope.member));
              $scope.target = JSON.parse(JSON.stringify(scope.member));
              $scope.cancel = function() {
                $scope.closeThisDialog($scope.target);
              }
              $scope.submit = function() {
                scope.member = $scope.target;
                $scope.closeThisDialog($scope.target);
              }
              if ($scope.rrInlineEditSelectFrom) {
                $scope.target = _.findWhere($scope.rrInlineEditSelectFrom,{id:scope.member.toString()}).id;
              }
            },
            plain: true
          })
        };
        
        element.removeAttr('rr-inline-edit');
        element.attr('edit-btn','launchDialog()');
        $compile(element)(scope);
        
        var camelCaseToTitleCase = function(text) {
          var result = text.replace( /([A-Z])/g, " $1" );
          var finalResult = result.charAt(0).toUpperCase() + result.slice(1);
          return finalResult;
        }
        
      }
    }
  })
